import { SharedModule } from '../../../shared/shared.module';
import { PartenairesDetailsComponent } from './partenaires-details.component';
import { PartenairesDetailsResolver } from './partenaires-details.resolver';
import {NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  imports: [
    NgbModule,
    SharedModule
  ],
  declarations: [PartenairesDetailsComponent],
  exports: [PartenairesDetailsComponent],
  providers: [PartenairesDetailsResolver]
})
export class PartenairesDetailsModule {}
